import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import emitter from "@/lib/emitter";
import { PurchaseDetails, PurchaseResponse, SubscriptionDetails, SubscriptionResponse } from "@/payments/types";
import { EVENTS } from "@/const";
import SystemIntegration from "./integrations";

export default {
  purchase(details: PurchaseDetails): Promise<PurchaseResponse> {
    return new Promise(async (resolve, reject) => {
      const onPurchased = (response?: PurchaseResponse) => {
        if (!response) {
          reject("Can't find response!");
          return;
        }
        emitter.off<PurchaseResponse>(EVENTS.PAYMENT_PURCHASED, onPurchased);
        resolve(response);
      };
      emitter.emit(EVENTS.PAYMENT_START_PURCHASE, {
        pricePackageId: details.pricePackageId,
        price: details?.price,
        purchaseSubject: details?.subject,
      });
      emitter.on<PurchaseResponse>(EVENTS.PAYMENT_PURCHASED, onPurchased);
    });
  },

  subscribe(details: SubscriptionDetails): Promise<SubscriptionResponse> {
    return new Promise(async (resolve, reject) => {
      const onSubscribed = (response?: SubscriptionResponse) => {
        if (!response) {
          reject("Can't find response!");
          return;
        }
        emitter.off<SubscriptionResponse>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
        resolve(response);
      };
      emitter.emit(EVENTS.PAYMENT_START_PURCHASE, {
        pricePackageId: details.pricePackageId,
        price: details.price,
        subscriptionSubject: details.subscriptionSubject,
      });
      emitter.on<SubscriptionResponse>(EVENTS.PAYMENT_SUBSCRIBED, onSubscribed);
    });
  },

  checkAllowStoreCard: (system: PaymentSystemPublic) => SystemIntegration(system).allowSaveCard,
};
